import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/src/app/(localized)/[locale]/book/BookRedirect.tsx");
